import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import AdminLogin from "./pages/AdminLogin";
import AdminInbox from "./pages/AdminInbox";
import AdminFollowups from "./pages/AdminFollowups";
import AdminNumbers from "./pages/AdminNumbers";
import AdminAlerts from "./pages/AdminAlerts";
import AdminQuotePage from "./pages/AdminQuotePage";
import AdminCustomer from "./pages/AdminCustomer";
import ErrorBoundary from "./components/common/ErrorBoundary";
import AdminJobs from "./pages/AdminJobs";
import AdminCalendar from "./pages/AdminCalendar";
import AdminCustomers from "./pages/AdminCustomers";
import AdminServices from "./pages/AdminServices";
import AdminReports from "./pages/AdminReports";
import PayQuote from "./pages/PayQuote";
import Unsubscribe from "./pages/Unsubscribe";
import AdminEmail from "./pages/AdminEmail";
import AdminExpenses from "./pages/AdminExpenses";
import AdminSettings from "./pages/AdminSettings";
import AdminPlan from "./pages/AdminPlan";
import RequireAuth from "./auth/RequireAuth";

const protect = (el) => <RequireAuth>{el}</RequireAuth>;

export default function App() {
  return (
    <BrowserRouter>
      <RouteBoundary>
      <Routes>
        {/* Public, no login: the customer pay page and the email unsubscribe page */}
        <Route path="/pay/:token" element={<PayQuote />} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />

        <Route path="/admin/login" element={<AdminLogin />} />

        {/* The four places you actually go */}
        <Route path="/admin" element={protect(<AdminInbox />)} />
        <Route path="/admin/followups" element={protect(<AdminFollowups />)} />
        <Route path="/admin/jobs" element={protect(<AdminJobs />)} />
        <Route path="/admin/numbers" element={protect(<AdminNumbers />)} />

        {/* Under More */}
        <Route path="/admin/calendar" element={protect(<AdminCalendar />)} />
        <Route path="/admin/customers" element={protect(<AdminCustomers />)} />
        <Route path="/admin/customers/:id" element={protect(<AdminCustomer />)} />
        <Route path="/admin/services" element={protect(<AdminServices />)} />
        <Route path="/admin/reports" element={protect(<AdminReports />)} />
        <Route path="/admin/alerts" element={protect(<AdminAlerts />)} />
        <Route path="/admin/email" element={protect(<AdminEmail />)} />
        <Route path="/admin/expenses" element={protect(<AdminExpenses />)} />
        <Route path="/admin/settings" element={protect(<AdminSettings />)} />
        <Route path="/admin/plan" element={protect(<AdminPlan />)} />
        <Route path="/admin/quote-page" element={protect(<AdminQuotePage />)} />

        {/* Old paths keep working */}
        <Route path="/admin/quotes" element={<Navigate to="/admin/jobs" replace />} />
        <Route path="/admin/pipeline" element={<Navigate to="/admin/jobs" replace />} />
        <Route path="/admin/messages" element={<Navigate to="/admin" replace />} />
        <Route path="/" element={<Navigate to="/admin" replace />} />
        <Route path="/login" element={<Navigate to="/admin/login" replace />} />

        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
      </RouteBoundary>
    </BrowserRouter>
  );
}

// A screen that crashes shows a friendly fallback (and alerts you) instead of
// a blank page; moving to another screen clears it.
function RouteBoundary({ children }) {
  const { pathname } = useLocation();
  return <ErrorBoundary resetKey={pathname}>{children}</ErrorBoundary>;
}
